import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "text-center",
  style: {"width":"64px","max-height":"48px"}
}
const _hoisted_2 = {
  class: "vertical-sticky",
  style: {"max-height":"48px"}
}
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "font-weight-bold text-right" }
const _hoisted_5 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              "show-select": "",
              headers: _ctx.headers,
              items: _ctx.invoiceData.matrix,
              width: "100%",
              density: "compact",
              "item-key": "id",
              class: "table table-striped"
            }, {
              "header.data-table-select": _withCtx(() => [
                _createVNode(_component_v_checkbox_btn, {
                  indeterminate: _ctx.isIndeterminate,
                  "model-value": _ctx.allSelected,
                  color: "primary",
                  density: "comfortable",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAllSelection($event))),
                  "hide-details": "auto"
                }, null, 8, ["indeterminate", "model-value"])
              ]),
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_1, [
                    _createVNode(_component_v_checkbox, {
                      "onUpdate:modelValue": ($event: any) => (_ctx.select(props.item, $event)),
                      ripple: false,
                      readonly: _ctx.readonly,
                      "model-value": props.item.selected,
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["onUpdate:modelValue", "readonly", "model-value"])
                  ]),
                  _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.client.name), 1),
                  (props.item.selected)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.quantities, (quantity, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index,
                            style: {"max-height":"48px"}
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((quantity.quantity) = $event),
                              type: "number",
                              class: "input-table",
                              style: {"width":"70px"}
                            }, null, 8, _hoisted_3), [
                              [
                                _vModelText,
                                quantity.quantity,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.computeTotal(props.item), undefined)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("td", {
                        key: 1,
                        colspan: props.item.quantities.length + 1,
                        class: "font-weight-bold"
                      }, null, 8, _hoisted_5))
                ])
              ]),
              _: 1
            }, 8, ["headers", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}